export function getIsUsingOfficeOnline(): boolean {
  // eslint-disable-next-line no-undef
  return Office.context.diagnostics.platform === Office.PlatformType.OfficeOnline;
}
